module.exports = __webpack_public_path__ + "img/logo-m2n.7a931deb.svg";